interface Props {
  id?: any
  query?: string
  recent?: string | number
  filter?: any
  page?: number
  limit?: number
  thread_id?: number | string
  content_id?: number | string
  generate?: string
  sort_field?: string
  sort_order?: string
  file_url?: string
  field?: string
  isYoutube?: boolean
  status?: string
  category?: string
  labels?: string
  tags?: string
  types?: string
  start_date?: string
  end_date?: string
  paginated?: boolean
  vector_annnouncements?: boolean
}

export const ManageContents = {
  list: ({
    id,
    query = '',
    recent = '',
    status = '',
    category = '',
    labels = '',
    tags = '',
    types = '',
    filter = [],
    page = 1,
    limit = 10,
    sort_field = '',
    start_date = '',
    end_date = '',
    sort_order = 'asc',
    paginated = true,
    vector_annnouncements = false
  }: Props) =>
    `content${
      id
        ? `?id=${id}`
        : `?q=${encodeURIComponent(query)}&page=${page}&limit=${limit}&sort_field=${sort_field}&sort_order=${sort_order}&status=${status}&category=${category}&labels=${labels}&tags=${encodeURIComponent(tags)}&types=${types}&start_date=${start_date}&end_date=${end_date}&paginated=${paginated}${
            vector_annnouncements ? `&vector_annnouncements=${vector_annnouncements}` : ''
          }`
    }`,
  post: `content`,
  tags: `content/tags`,
  createEdit: ({ id }: { id?: string }) => `new-content${id ? `/${id}` : ''}`,
  update: (id?: number) => `content?id=${id}`,
  delete: (id?: any) => `content?id=${id}`,
  permission: {
    get: (id?: number) => `manage_content?id=${id}`,
    patch: (id?: number) => `manage_content?id=${id}`
  },
  generate: `generate-investor-content`,
  generateContent: ({ content_id, field }: Props | any) =>
    `generate-content-text?${
      content_id ? `content_id=${content_id ?? null}` : ''
    }${field ? `&field=${field}` : ''}`,
  generateIndividulaContent: ({ thread_id, field, isYoutube = false }: Props) =>
    `generate-content-text?thread_id=${thread_id ?? ''}&conversation_id=${
      thread_id ?? ''
    }&field=${field}&is_youtube=${isYoutube}`,
  fetchIresscategory: (query: string, all: boolean) =>
    `content/iress-category?q=${query}&all=${all}`
}
